// extracted by mini-css-extract-plugin
module.exports = {"OuterCard":"OuterCard_OuterCard__7-H7K","middle":"OuterCard_middle__15XdP","okIcon":"OuterCard_okIcon__2U-u_","title":"OuterCard_title__2-AkN","content":"OuterCard_content__1tifS"};